// ** React
import { useContext } from "react";

// ** Redux
import { useDispatch, useSelector } from "react-redux";
import { getPosts } from "store/modules/main-pages/posts/get-posts.action";

// ** Third Party Components
import { useTranslation } from "react-i18next";

// ** Custom Components
import PeriodSelector from "components/layout/PeriodSelector";

// ** Utils & Helpers
import filterPeriodFn from "helpers/mediaFilters/filterPeriod";

// ** Context
import AuthContext from "contexts/authContext";

// #####################################################

export const PostsPeriodFilter = () => {
	const { t } = useTranslation(["common"]);

	const dispatch = useDispatch();

	const isAuth = useContext(AuthContext);

	const periodFromStore = useSelector((state) => state.sharedFilters.period);

	const filterPeriod = filterPeriodFn({
		period: periodFromStore.period,
		fromYear: periodFromStore.startDate.year,
		fromMonth: periodFromStore.startDate.month,
		t,
	});

	const handlePeriodSelect = ({ value, number }) => {
		const select = () => {
			if (
				filterPeriod.selected.year &&
				value !== "latest" &&
				value !== "total" &&
				value &&
				!value.includes("-")
			) {
				return `${number}-${filterPeriod.selected.year}`;
			} else if (filterPeriod.selected.year && value === "total") {
				return filterPeriod.selected.year;
			} else {
				return value || "latest";
			}
		};

		const selectedPeriod = select();

		const newFilterPeriod = filterPeriodFn({
			period: selectedPeriod,
			fromYear: periodFromStore.startDate.year,
			fromMonth: periodFromStore.startDate.month,
			t,
		});

		const newFilterPeriodApiParams = newFilterPeriod.asApiParam();

		dispatch(
			getPosts({
				filters: {
					period: {
						selectedDate: {
							...newFilterPeriodApiParams,
						},
						period: selectedPeriod,
						year: newFilterPeriod.selected.date.year,
					},
				},
				isAuth,
			})
		);
	};

	const handleYearSelect = (newYear) => {
		dispatch(
			getPosts({
				filters: {
					year: newYear,
				},
				isAuth,
			})
		);
	};

	// #####################################################

	return (
		<PeriodSelector
			periodItems={filterPeriod.periods}
			periodSelected={filterPeriod.selected.period}
			periodSetSelected={handlePeriodSelect}
			yearItems={filterPeriod.years}
			yearSelected={filterPeriod.selected.year}
			yearSetSelected={handleYearSelect}
		/>
	);
};

// #####################################################

export default PostsPeriodFilter;

// #####################################################
